export default __webpack_public_path__ + "static/my-one-and-only-you-c5faa550c686f718e2cd72eb54e72a51.jpg";